<template>
    <div id="formula_setting">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <template>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-button @click="add" v-if="judge('Formula_Create')" type="primary" icon="el-icon-plus">
                              {{ $t('newlyAdded') }}</el-button>
                        </el-col>
                    </el-row>
                    <el-table ref="multipleTable"
                              :data="tableData1"
                              border
                              stripe
                              style="width: 100%">
                        <el-table-column prop="index"
                                         :label="$t('SN')"
                                         min-width="5%">
                        </el-table-column>
                        <el-table-column prop="cityName"
                                         :label="$t('City')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column prop="factoryName"
                                         :label="$t('Campus')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column prop="formulaName"
                                         :label="$t('FormulaName')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column prop="formula"
                                         :label="$t('Formula')"
                                         min-width="30%">
                        </el-table-column>
                        <el-table-column prop="unit"
                                         :label="$t('Unit')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column :label="$t('Action')"
                                         min-width="20%">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                           v-if="judge('Formula_Update')"
                                           type="primary"
                                           @click="edit(scope.row)">{{ $t('Edit') }}
                                </el-button>
                                <el-popconfirm :title="$t('DeleteConfirm')" @onConfirm="deleteByid(scope.row.id)">
                                    <el-button v-if="judge('Formula_Delete')" type="danger" size="mini" style=" margin-left: 10px;" slot="reference">
                                      {{ $t('Delete') }}
                                    </el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :page-size="10"
                            @current-change="handleCurrentChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>
            </el-main>
        </el-scrollbar>

        <el-dialog :title="$t('EditFormula')" :visible.sync="dialogEditFormula" width="60%" top="10vh">
            <el-form ref="requestData" :model="requestData" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select :disabled="clickBtn == 'edit'" v-model="requestData.cityId"
                               @change="getFactoryByName(requestData.cityId,'0')"
                               style="width: 23.5vw;">
                        <el-option v-for="(item,index) in cityList" :key="index" :value="item.id"
                                   :label="item.cityName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">
                    <el-select :disabled="clickBtn == 'edit'" v-model="requestData.factoryId" style="width: 23.5vw;">
                        <el-option v-for="(item,index) in factoryList" :key="index" :value="item.id"
                                   :label="item.factoryName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('FormulaName')">
                    <el-input :value="requestData.formulaName" disabled style="width: 23.5vw;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('power')">
                    <div>{{ $t('EveryKWh') }}=
                        <el-input v-model="requestData.formulaValueJson.powerConverFactor" type="number"
                                  style="width: 120px;"></el-input>
                      {{ $t('tonsOfCarbonEmissions') }}
                    </div>
                </el-form-item>
                <el-form-item :label="$t('NaturalGas')">
                    <div>{{$t('Every10KM')}}=
                        <el-input v-model="requestData.formulaValueJson.naturalGasConverFactor" type="number"
                                  style="width: 120px;"></el-input>
                      {{ $t('tonsOfCarbonEmissions') }}
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Steam')">
                    <div>{{ $t('EveryTon') }}=
                        <el-input v-model="requestData.formulaValueJson.steamConverFactor" type="number"
                                  style="width: 120px;"></el-input>
                      {{ $t('tonsOfCarbonEmissions') }},({{ $t('millionkilojoules') }})
                    </div>
                </el-form-item>
                <!--                <el-form-item label="公式运算">-->
                <!--                    <div style="width: 100%;">-->
                <!--                        <span>A1×</span>-->
                <!--                        <el-input type="number" v-model="requestData.formulaValueJson.powerConverFactor"-->
                <!--                                  style="width: 80px;"></el-input>-->
                <!--                        <span>+B1×</span>-->
                <!--                        <el-input type="number" v-model="requestData.formulaValueJson.naturalGasConverFactor"-->
                <!--                                  style="width: 80px;"></el-input>-->
                <!--                        + <span>C1×</span>-->
                <!--                        <el-input type="number" v-model="requestData.formulaValueJson.steamConverFactor"-->
                <!--                                  style="width: 80px;"></el-input>-->
                <!--                    </div>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="公式说明">-->
                <!--                    <div><label style="color:#F56C6C;">碳排放量 = 电力(每万千瓦时) + 天然气(每万立方米) + 蒸汽(每百万千焦)</label></div>-->
                <!--                </el-form-item>-->
                <el-form-item :label="$t('Unit')">
                    <!--                    <el-input v-model="requestData.unit" style="width: 23.5vw;"></el-input>-->
                    <el-select v-model="requestData.formulaValueJson.carbonEmissionUnit" :placeholder="$t('el.select.placeholder')"
                               style="width: 23.5vw;">
                        <el-option value="吨" :label="$t('ton')"></el-option>
                        <el-option value="万吨" :label="$t('thousandTon')"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input v-model="requestData.remark" style="width: 23.5vw;" type="textarea" :rows="3"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogEditFormula = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {fancha} from '../../utils/util'
    import {
        getCityAll,
        getFormulaAll,
        FormulaCreate,
        FormulaUpdate, getFactoryAll, GetByCityId, getFactoryByName, FormulaDelete
    } from '../../api/api';
    import {judgePermission} from '../../utils/util'
    export default {
        name: "Formula_setting",
        data() {
            return {
                dialogEditFormula: false,
                area: JSON.parse(sessionStorage.getItem("area")),
                requestData: {
                    id: '',
                    cityId: "",
                    cityName: "",
                    cityCode: "",
                    factoryId: "",
                    factoryCode: "",
                    factoryName: "",
                    formulaName: this.$t('CarbonEmissionFormula'),
                    formulaCode: "",
                    formulaType: "CarbonEmissionFormula",
                    // unit: "",
                    remark: "",
                    formulaValueJson: {
                        factoryCode: "",
                        electricPowerUnit: this.$t('degree'),
                        carbonEmissionUnit: "",
                        powerConverFactor: "",
                        naturalGasConverFactor: "",
                        steamConverFactor: ""
                    },
                },
                factoryList: [],
                cityList: [],
                tableData1: [],
                total: 0,
                currentPage: 0,
                clickBtn: "",
                FactoryCode: "",
                pageSize:10,
            }
        },
        mounted() {
            this.getAllConfig()
            this.getAllCity()
        },
        methods: {
            judge(e){
                return judgePermission(e)
            },
            handleCurrentChange(val) {
                this.currentPage = (val - 1) * this.pageSize
                this.getAllConfig()
            },
            deleteByid(e) {
                var that = this
                FormulaDelete(e).then(res => {
                    if (res.success) {
                        that.$message.success(this.$t('deleteSuccessful'))
                        that.getAllConfig()
                    }
                })
            },
            find(str, cha, num) {
                var x = str.indexOf(cha);
                for (var i = 0; i < num; i++) {
                    x = str.indexOf(cha, x + 1);
                }
                return x;
            },
            edit(e) {

                var data = fancha(e.factoryId)



                this.clickBtn = "edit"
                this.dialogEditFormula = true
                this.requestData = e
                this.requestData.cityId = this.area[data[0]].value
                this.getFactoryByName(this.requestData.cityId, "1")
                // this.requestData.id=e.id
                // this.requestData.cityName=e.cityName
                // this.requestData.factoryId=e.factoryId
                // this.requestData.unit=e.unit
                // this.requestData.remark=e.remark
                // this.requestData.formulaValueJson = e.formulaValueJson
            },
            getAllConfig() {
                var that = this
                getFormulaAll('', 'id ASC', this.pageSize, this.currentPage, this.FactoryCode).then(res => {

                    if (res.success) {
                        that.tableData1 = res.result.items
                        that.total = res.result.totalCount
                        that.tableData1.map((i, j) => {
                            i.index = j + 1
                            i.formula = `${i.formulaValueJson.powerConverFactor}*电力+${i.formulaValueJson.naturalGasConverFactor}*天然气+${i.formulaValueJson.steamConverFactor}*蒸汽`
                        })
                    } else {
                        that.$message.error(res.error.message)
                    }
                })
            },
            getAllCity(FilterText) {
                var that = this
                getCityAll(FilterText).then(res => {
       
                    if (res.success) {
                        that.cityList = res.result.items
                        that.getAllFactory()
                    }
                })
            },
            getAllFactory(FilterText) {
                var that = this
                getFactoryAll(FilterText).then(res => {
      
                    if (res.success) {
                        that.factoryList = res.result.items
                    }
                })
            },
            getFactoryByName(FilterText, e) {
                var that = this
                GetByCityId(FilterText).then(res => {
                
                    if (res.success) {
                        that.factoryList = res.result
                        if (e == "0") {
                            that.requestData.factoryId = ''
                        }
                    }
                })
            },
            onSubmit() {
                var that = this
                this.cityList.map(item => {
                    if (item.id == that.requestData.cityId) {
                        that.requestData.cityName = item.cityName
                        that.requestData.cityCode = item.cityCode
                    }
                })
                this.factoryList.map(item => {
                    if (item.id == that.requestData.factoryId) {
                        that.requestData.factoryCode = item.factoryCode
                        that.requestData.factoryName = item.factoryName
                    }
                })
                this.requestData.formulaValueJson.factoryCode = this.requestData.factoryCode
  
                var data = this.requestData
                delete data.index
                if (this.clickBtn == "add") {
                    delete data.id
                    FormulaCreate(data).then(res => {
             
                        if (res.success) {
                            that.$message.success(this.$t('Creation'))
                            that.dialogEditFormula = false
                            that.getAllConfig()
                        } else {
                            that.$message.error(res.error.message)
                        }
                    })
                } else {
                    FormulaUpdate(data).then(res => {

                        if (res.success) {
                            that.$message.success(this.$t('Update'))
                            that.dialogEditFormula = false
                            that.getAllConfig()
                        } else {
                            that.$message.error(res.error.message)
                        }
                    })
                }

            },
            add() {
                this.dialogEditFormula = true
                this.clickBtn = "add"
                this.requestData = {
                    id: '',
                    cityId: "",
                    cityName: "",
                    cityCode: "",
                    factoryId: "",
                    factoryCode: "",
                    factoryName: "",
                    formulaName: this.$t('CarbonEmissionFormula'),
                    formulaCode: "",
                    formulaType: "CarbonEmissionFormula",
                    // unit: "",
                    remark: "",
                    formulaValueJson: {
                        factoryCode: "",
                        electricPowerUnit: this.$t('degree'),
                        carbonEmissionUnit: "",
                        powerConverFactor: "",
                        naturalGasConverFactor: "",
                        steamConverFactor: ""
                    },
                }
            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

    #formPer .el-form-item__content {
        line-height: 35px;
        border-left: 1px solid #EBEEF5;
        padding-left: 10px;
    }

    #formPer > .el-form-item {
        margin-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
    }

    #formPer .noborder .el-form-item__content {
        border: 0;
    }

    #formPer .noborder {
        border: 0;
        margin-top: 20px;
    }
</style>
